import { ArrowRight } from 'lucide-react';

/**
 * Shared dashboard card: a quiet grey header strip (title, optional link at the right) over a white body.
 * Structure comes from 1px borders, not shadows.
 */
const Panel = ({ title, subtitle, onViewAll, actionLabel = 'View all', testId, bodyClassName = 'p-4', children }) => (
  <section className="bg-card border border-border rounded-md overflow-hidden" data-testid={testId}>
    <header className="flex items-center justify-between gap-3 px-4 py-2.5 bg-muted border-b border-border">
      <div className="min-w-0">
        <h2 className="text-sm font-medium text-muted-foreground">{title}</h2>
        {subtitle && <p className="text-xs text-muted-foreground">{subtitle}</p>}
      </div>
      {onViewAll && (
        <button
          type="button"
          onClick={onViewAll}
          className="inline-flex shrink-0 items-center gap-1 text-sm text-foreground underline underline-offset-2 hover:no-underline"
          data-testid={testId ? `${testId}-view-all` : undefined}
        >
          {actionLabel} <ArrowRight className="w-3.5 h-3.5" />
        </button>
      )}
    </header>
    <div className={bodyClassName}>{children}</div>
  </section>
);

export default Panel;
